import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CcrcTypeAPageContent } from '@/features/ccrc-type-a';

import { selectFeatureFlags } from '@/model';

export function CcrcTypeAProductPage({ clientId }: ClientIdProps) {
  const featureFlags = useSelector(selectFeatureFlags);

  if (!featureFlags.ccrcTypeAProducts) {
    return (
      <Navigate
        to={`/clients/${clientId}/onboarding/funding-sources`}
        replace
      />
    );
  }

  return <CcrcTypeAPageContent clientId={clientId} />;
}
